// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"65":"7c1fc5da","368":"25c9593f","410":"f3a54eab","551":"36a8fe1d","625":"cca6715e","691":"c82b12ad","787":"d5ce303e"}[chunkId] + ".chunk.js";
};